export const COLLECTION = {
  USERS: 'users',
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings',
  BUSINESS_EVENTS: 'business-events',
  REPORTS: 'reports',
  USER_SUBSCRIPTIONS: 'subscriptions',
  API_TOKENS: 'api-tokens',
  STATS_PER_MONTH: 'stats-per-month',
} as const;
